/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, DoCheck, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {FabMessageService} from '@fabric/components/message';
import {MarketAreaPlanningMarketMap} from '../../../../models/market-area-planning-market-map.model';
import {PlanningMarket} from '../../../../models/planning-market.model';
import {SelectableOptions} from '../../../../models/selectable-options';

@Component({
    selector: 'app-edit-market-area-pop-up',
    templateUrl: './edit-market-area-pop-up.component.html',
    styleUrls: ['./edit-market-area-pop-up.component.scss'],
    standalone: false
})
export class EditMarketAreaPopUpComponent implements DoCheck {
  editMktAreaForm: FormGroup;
  title = 'Add';
  regionsPlanningMarketList: PlanningMarket[];
  marketAreasPlanningMarketList: MarketAreaPlanningMarketMap[];
  displayedColumns: string[] = ['plngMkt'];
  dataSource: MatTableDataSource<string> = new MatTableDataSource(null);
  selectedValues: any;
  mktArea: string;

  planningMarkets: SelectableOptions = new SelectableOptions();

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public dialogRef: MatDialogRef<EditMarketAreaPopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.title) {
        this.dialogRef.close();
      }
      this.title = data.title;
      this.mktArea = data.mktArea;
      this.regionsPlanningMarketList = data.regionsPlanningMarketList;
      this.marketAreasPlanningMarketList = data.marketAreasPlanningMarketList;
      this.regionsPlanningMarketList.forEach(entry => this.planningMarkets.options.push(entry.plngMkt));
      this.marketAreasPlanningMarketList.forEach(e => this.planningMarkets.selectedOptions.push(e.plngMkt));

    }
    this.editMktAreaForm = new FormGroup({
      planningMarketMappingList: new FormControl(this.planningMarkets.selectedOptions, [Validators.required])
    });
    this.dataSource = new MatTableDataSource(this.editMktAreaForm.controls.planningMarketMappingList.value);
  }

  /**
   * Checks if the selected planning markets has changed, if so it updates the planning market list
   */
  ngDoCheck(): void {
    if (this.editMktAreaForm.controls.planningMarketMappingList.value !== this.planningMarkets.selectedOptions) {
      this.planningMarkets.selectedOptions = this.editMktAreaForm.controls.planningMarketMappingList.value;
      this.dataSource = new MatTableDataSource(this.editMktAreaForm.controls.planningMarketMappingList.value);
    }
  }

  /**
   * Close popup window.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Return new value to add it to DB.
   */
  editValue(): void {
    this.dialogRef.close({
      data: {
        selectedPlanningMarkets: this.editMktAreaForm.controls.planningMarketMappingList.value
      }
    });
  }
}
